export const GET_SERVER_TIME_START = 'GET_SERVER_TIME_START'
export const GET_SERVER_TIME_SUCCESS = 'GET_SERVER_TIME_SUCCESS'
export const GET_SERVER_TIME_FAILED = 'GET_SERVER_TIME_FAILED'
export const UPDATE_SERVER_TIME = 'UPDATE_SERVER_TIME'
